export default __webpack_public_path__ + "static/media/virtTechCampBgSmall.45b2a497.jpg";